'use client'

import React, { FC } from 'react'

import { useRouter } from 'next/navigation'
import styled, { css } from 'styled-components'

import { Txt, StandardButton } from 'src/components/atoms'
import { LogoWithText } from 'src/components/molecules'

import { mediaQuery } from 'src/responsive'
import { Routes } from 'src/routes'

const StyledLogo = styled(LogoWithText)`
  width: 16rem;
`

const TabletBgText = css`
  font-size: 17rem !important;
`
const BgText = styled(Txt)`
  font-size: 42vw;
  color: #00989a;
  background: -webkit-linear-gradient(
    261.6deg,
    #d9d200 -9.85%,
    #a7c69c 36.28%,
    #00989a 79.75%,
    #060e6d 114.89%
  );
  -webkit-background-clip: text; //テキストでくり抜く
  -webkit-text-fill-color: transparent; //くり抜いた部分は背景を表示
  letter-spacing: 0.1em;
  opacity: 0.1;
  font-weight: 700;
  position: absolute;
  line-height: 1;

  left: 50%;
  transform: translateX(-50%);

  ${mediaQuery.greaterTablet`${TabletBgText}`}
`

const NotFoundTxt = styled(Txt)`
  font-size: 1.7rem;
  text-align: center;
  letter-spacing: 0.2em;
  font-weight: 700;
`

type Props = {
  className?: string
  statusCode?: number
}

export const DefaultError: FC<Props> = ({ className, statusCode = 404 }) => {
  const router = useRouter()

  const descriptionTxt =
    statusCode === 500
      ? '予期せぬエラーが発生しました。システム管理者にご連絡ください。'
      : 'お探しのページが見つかりません。一時的にアクセスできない状況にあるか、削除された可能性があります。'

  return (
    <div className={className}>
      <div className="tw-text-center tw-px-s-2">
        <StyledLogo className="tw-inline-block" />

        <div className="tw-relative tw-mt-s0 tw-flex tw-flex-col tw-items-center">
          <BgText fontType="alphabet">{statusCode}</BgText>

          <div className="tw-pt-s0">
            <NotFoundTxt fontType="alphabet" className="tw-text-roovPrimary-default">
              PAGE NOT FOUND
            </NotFoundTxt>
            <Txt className="tw-mt-s2">{descriptionTxt}</Txt>
            <Txt className="tw-text-standardText-secondary tw-mt-s-1">
              {`error code：${statusCode}`}
            </Txt>
          </div>

          <StandardButton
            prependIconPath="home/soft/line"
            text="TOPへ戻る"
            size="l"
            onClick={async () => router.push(Routes.SignIn.path)}
            className={`tw-mt-s5 tw-hidden tablet:tw-inline-block ${
              statusCode === 500 ? 'tw-invisible' : 'tw-visible'
            }`}
          />
        </div>
      </div>
    </div>
  )
}
